<div class="scaffold-bool">
  <scaffold-toggle-slide status="info" (change)="updateSwitch()" [(ngModel)]="switchValue" [disable]="checkDisable()" [position]="item.position">
    {{item.translation_key_label||item.label| translation|translationFromString}} <span nbSuffix *ngIf="item.helpText||item.translation_key_help" [pTooltip]="item.translation_key_help||item.helpText| translation|translationFromString | transformText :item?.text_transform_key_help"> <i class="fas fa-question-circle"></i> </span>
  </scaffold-toggle-slide>

</div>
